import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '../../../create-mock-endpoint';

export const walletUserGiftBalanceAdjust = http.patch(
  createMockEndpoint('/wallet_user/:walletUserId/gift_balance_adjustment'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
